import { useEffect } from "react";
import { scrollToTop } from "@/lib/utils";
import ContactSection from "@/components/contact/ContactSection";

export default function ContactPage() {
  useEffect(() => {
    scrollToTop();
  }, []);
  
  return (
    <>
      <div className="pt-24 pb-12 bg-[#f8f9fa]">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h1 className="font-serif text-4xl md:text-5xl font-bold text-[#1a365d] mb-4">Contact Us</h1>
            <div className="w-24 h-1 bg-[#7d9b76] mx-auto mb-6"></div>
            <p className="max-w-3xl mx-auto text-lg">
              Have questions or ready to get started? Get in touch with SW Accounting today. We're here to help with all your accounting and financial management needs.
            </p>
          </div>
        </div>
      </div>
      
      <ContactSection />
      
      <div className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-serif text-3xl font-bold text-[#1a365d] mb-10 text-center">Frequently Asked Questions</h2>
            
            <div className="space-y-8">
              <div className="bg-[#f8f9fa] p-6 rounded-lg">
                <h3 className="font-serif text-xl font-bold text-[#1a365d] mb-3">What services do you offer?</h3>
                <p>
                  SW Accounting provides a wide range of financial services including bookkeeping, payroll automation, sales tax filing, financial reporting, auditing & record examination, HR support, QuickBooks setup & optimization, and small business financial strategy. Our services can be tailored to meet your specific business needs.
                </p>
              </div>
              
              <div className="bg-[#f8f9fa] p-6 rounded-lg">
                <h3 className="font-serif text-xl font-bold text-[#1a365d] mb-3">How much do your services cost?</h3>
                <p>
                  Our pricing varies depending on the specific services needed and the size and complexity of your business. We offer customized packages to ensure you're only paying for what you need. Please schedule a consultation for a personalized quote based on your requirements.
                </p>
              </div>
              
              <div className="bg-[#f8f9fa] p-6 rounded-lg">
                <h3 className="font-serif text-xl font-bold text-[#1a365d] mb-3">Do you work with businesses outside of Utah?</h3>
                <p>
                  Yes! While SW Accounting is based in Utah, we serve clients throughout the United States. Our digital capabilities allow us to work effectively with businesses regardless of location, providing the same high level of service to all our clients.
                </p>
              </div>
              
              <div className="bg-[#f8f9fa] p-6 rounded-lg">
                <h3 className="font-serif text-xl font-bold text-[#1a365d] mb-3">How do I get started with SW Accounting?</h3>
                <p>
                  Getting started is easy! Simply schedule a consultation through our booking page, or contact us directly by phone or email. During your initial consultation, we'll discuss your needs, answer your questions, and outline a plan tailored to your business.
                </p>
              </div>
              
              <div className="bg-[#f8f9fa] p-6 rounded-lg">
                <h3 className="font-serif text-xl font-bold text-[#1a365d] mb-3">What makes SW Accounting different from other accounting services?</h3>
                <p>
                  What sets us apart is our personalized approach and Sarah's 20+ years of expertise. We don't just provide numbers – we offer tailored financial strategies, clear communication, and ongoing support to help your business grow. We take the time to understand your unique needs and build lasting partnerships based on trust and results.
                </p>
              </div>
            </div>
            
            <div className="mt-12 text-center">
              <p className="text-lg mb-4">Still have questions? We're here to help!</p>
              <div className="flex flex-col sm:flex-row justify-center gap-4">
                <a 
                  href="mailto:sarah@swaccountingpro.com" 
                  className="inline-flex items-center justify-center bg-[#1a365d] text-white px-6 py-3 rounded-md hover:bg-opacity-90 transition-all duration-300"
                >
                  <i className="fas fa-envelope mr-2"></i> Email Us
                </a>
                <a 
                  href="tel:8017916900" 
                  className="inline-flex items-center justify-center bg-[#7d9b76] text-white px-6 py-3 rounded-md hover:bg-opacity-90 transition-all duration-300"
                >
                  <i className="fas fa-phone mr-2"></i> Call: 801-791-6900
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
